<template>
    <div :class="fieldClasses">
        <label class="form-field__label" :for="name">{{ label }}</label>
        <select
            :class="[
                'form-field__select',
                { 'form-field__control--error': errors !== null },
            ]"
            :name="name"
            :id="name"
            :value="modelValue"
            @input="updateValue($event.target.value)"
        >
            <option disabled selected value>{{ placeholder || 'Wybierz...' }}</option>
            <option
                v-for="(val, index) in values"
                :key="index"
                :value="index"
                v-html="val"
                :selected="index == value"
            ></option>
        </select>
        <ul class="form-field__error" v-if="errors">
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
        <p class="form-field__extra" v-if="extraInfo" v-html="extraInfo"></p>
    </div>
</template>

<script>
export default {
    props: [
        'label',
        'values',
        'name',
        'placeholder',
        'size',
        'disactive',
        'errorMessages',
        'extraInfo',
        'modelValue',
    ],

    methods: {
        updateValue(value) {
            this.$emit('input', value);
            if (this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        },
    },
    data() {
        return {
            value: '',
        };
    },
    computed: {
        fieldClasses() {
            const classes = ['form-field'];
            if (this.size) {
                classes.push(this.size);
                if (this.size === 'form-group--small') {
                    classes.push('form-field--small');
                }
            }
            if (this.disactive === true) {
                classes.push('form-field--hidden');
            }
            return classes;
        },
        errors: function () {
            if (
                this.errorMessages &&
                this.name in this.errorMessages &&
                this.value === ''
            ) {
                return this.errorMessages[this.name];
            }

            return null;
        },
    },
    watch: {
        errorMessages: function () {
            this.value = '';
        },
    },
};
</script>
